import {createBrowserRouter, Navigate} from "react-router-dom";
import App from "../components/App/App";
import Auth from "../pages/Auth/Auth";
import Login from "../pages/Auth/Login/Login";
import Register from "../pages/Auth/Register/Register";
import ForgotPassword from "../pages/Auth/ForgotPassword/ForgotPassword";
import MainLayout from "../components/MainLayout/MainLayout";
import HomePage from "../pages/HomePage/HomePage";
import ServicesPage from "../pages/ServicesPage/ServicesPage";
import PlansPage from "../pages/PlansPage/PlansPage";
import TrainersPage from "../pages/TrainersPage/TrainersPage";
import TrainerInfoPage from "../pages/TrainerInfoPage/TrainerInfoPage";
import SchedulePage from "../pages/SchedulePage/SchedulePage";
import AboutUsPage from "../pages/AboutUsPage/AboutUsPage";
import ContactUsPage from "../pages/ContactUsPage/ContactUsPage";
import AccountPage from "../pages/AccountPage/AccountPage";
import AccountSettings from "../pages/AccountPage/AccountSettings/AccountSettings";
import AccountSettingsEdit from "../pages/AccountPage/AccountSettingsEdit/AccountSettingsEdit";
import AccountSubscriptions from "../pages/AccountPage/AccountSubscriptions/AccountSubscriptions";
import AccountPaymentHistory from "../pages/AccountPage/AccountPaymentHistory/AccountPaymentHistory";
import AccountBooking from "../pages/AccountPage/AccountBooking/AccountBooking";
import VenuesPage from "../pages/VenuesPage/VenuesPage";
import VenuesBookPage from "../pages/VenuesBookPage/VenuesBookPage";
import ErrorPage from "../pages/ErrorPage/ErrorPage";
import AccountCards from "../pages/AccountPage/AccountCards/AccountCards";
import AccountLoyaltyPoints
    from "../pages/AccountPage/AccountLoyaltyPoints/AccountLoyaltyPoints";
import AccountLoyaltyPointsHowItWorks
    from "../pages/AccountPage/AccountLoyaltyPoints/AccountLoyaltyPointsHowItWorks/AccountLoyaltyPointsHowItWorks";


const router = createBrowserRouter([
    {
        path: "", element: <App/>, children: [
            {
                path: "", element: <MainLayout/>, children: [
                    {index: true, element: <HomePage/>},
                    {path: "services", element: <ServicesPage/>},
                    {path: "plans", element: <PlansPage/>},
                    {path: "trainers", element: <TrainersPage/>},
                    {path: "trainers/:id", element: <TrainerInfoPage/>},
                    {path: "schedule", element: <SchedulePage/>},
                    {path: "venues", element: <VenuesPage/>},
                    {path: "venues/:id", element: <VenuesBookPage/>},
                    {path: "about-us", element: <AboutUsPage/>},
                    {path: "contact-us", element: <ContactUsPage/>},
                    {
                        path: "/account",
                        element: <AccountPage/>,
                        children: [
                            {
                                path: "",
                                element: <Navigate to="settings" />,
                            },
                            {
                                path: "settings",
                                element: <AccountSettings/>
                            },
                            {
                                path: "settings/edit",
                                element: <AccountSettingsEdit/>
                            },
                            {
                                path: "subscriptions",
                                element: <AccountSubscriptions/>
                            },
                            {
                                path: "payment-history",
                                element: <AccountPaymentHistory/>
                            },
                            {
                                path: "bookings",
                                element: <AccountBooking/>
                            },
                            {
                                path: "cards",
                                element: <AccountCards/>
                            },
                            {
                                path: "loyalty-points",
                                element: <AccountLoyaltyPoints/>
                            },
                            {
                                path: "loyalty-points/how-it-works",
                                element: <AccountLoyaltyPointsHowItWorks/>
                            }
                        ]
                    }
                ]
            },
            {
                path: "auth", element: <Auth/>, children: [
                    {path: "login", element: <Login/>},
                    {path: "register", element: <Register/>},
                    {path: "forgot-password", element: <ForgotPassword/>}
                ]
            },
            {path: "/*", element: <ErrorPage/>}
        ]

    }
]);

export default router;